import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CopyToClipboardButton, FlexBox, Icon, Text, Tooltip, } from '@dixa/lib-shared-habla';
import { twilioActions } from 'app/middleware/twilio/actions/twilioActions';
import { composeEmailActions } from 'components/shared/composeEmail/actions/composeEmailActions';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';
import styles from './contactItem.module.scss';
export const ContactItem = ({ user, label, address, addressHref, addressTooltip, icon, addressFormat = (address) => address, }) => {
    const dispatch = useAppDispatch();
    const { telephonyFromNumber } = useAppSelector((state) => ({
        telephonyFromNumber: state.telephony.selectedFromNumber,
    }));
    const handleOnClick = (e) => {
        e.preventDefault();
        if (!addressHref) {
            return;
        }
        if (addressHref.startsWith('tel:') || addressHref.startsWith('callto:')) {
            dispatch(twilioActions.twilioMakeCall({
                userId: user.id,
                toNumber: address,
                fromNumber: telephonyFromNumber === null || telephonyFromNumber === void 0 ? void 0 : telephonyFromNumber.e164_format,
            }));
        }
        if (addressHref.startsWith('mailto:')) {
            dispatch(composeEmailActions.composeEmailOpenModal({
                initialValues: { toUser: [{ user: Object.assign(Object.assign({}, user), { email: address }) }] },
            }));
        }
    };
    return (_jsxs(FlexBox, Object.assign({ alignItems: "center", gap: "200", width: "100%", as: "li" }, { children: [_jsx(Icon, { name: icon }), _jsx(Text.Paragraph, Object.assign({ variant: "1", subdued: true, wrap: "nowrap" }, { children: label })), _jsx(FlexBox, Object.assign({ className: styles.addressContainer, flex: "1", padding: "0 0 0 200", justifyContent: "end" }, { children: _jsx(Tooltip, Object.assign({ content: addressTooltip, dark: true }, { children: addressHref ? (_jsx("a", Object.assign({ className: styles.address, href: addressHref, onClick: handleOnClick }, { children: addressFormat(address) }))) : (_jsx("span", Object.assign({ className: styles.address }, { children: addressFormat(address) }))) })) })), _jsx(Tooltip, Object.assign({ content: "Copy", dark: true }, { children: _jsx(CopyToClipboardButton, { textToCopy: address, tooltip: false, clickedProps: { icon: 'done' }, buttonProps: { variant: 'tertiary', icon: 'copy' } }) }))] })));
};
